import { z } from 'zod';
import { RegionSchema } from '../base/region.js';
import { serviceEventType, TarpulatorEntityTypeName, TarpulatorServiceEventBaseSchema, } from './service.js';
export const tarpulatorRegionEventType = (eventName) => serviceEventType(TarpulatorEntityTypeName.region, eventName);
export const TarpulatorRegionEventTypeNameSchema = z.enum(['created', 'deleted', 'updated']);
export const TarpulatorRegionEventTypeName = TarpulatorRegionEventTypeNameSchema.enum;
export const TarpulatorRegionEventSchema = TarpulatorServiceEventBaseSchema.extend(z.object({
    type: tarpulatorRegionEventType(),
    region: z.unknown(),
}).shape);
export const TarpulatorRegionCreatedEventSchema = TarpulatorRegionEventSchema.extend(z.object({
    type: tarpulatorRegionEventType(TarpulatorRegionEventTypeName.created),
    region: RegionSchema,
}).shape);
export const TarpulatorRegionUpdatedEventSchema = TarpulatorRegionEventSchema.extend(z.object({
    type: tarpulatorRegionEventType(TarpulatorRegionEventTypeName.updated),
    region: RegionSchema,
}).shape);
export const TarpulatorRegionDeletedEventSchema = TarpulatorRegionEventSchema.extend(z.object({
    type: tarpulatorRegionEventType(TarpulatorRegionEventTypeName.deleted),
    region: RegionSchema,
}).shape);
